import { useState, useEffect } from 'react';

// Funzione di debounce per ottimizzare il resize
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const useBackgroundImage = (shouldShowBackground) => {
  const [backgroundImage, setBackgroundImage] = useState('none');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!shouldShowBackground) {
      setBackgroundImage('none');
      setIsLoading(false);
      return;
    }

    const loadImage = async () => {
      setIsLoading(true);
      const isMobile = window.innerWidth <= 600;
      const imagePath = isMobile ? '/backgroundmobile.webp' : '/backgroundHD.webp';
      
      try {
        const img = new Image();
        img.src = imagePath;
        await img.decode();
        setBackgroundImage(`url(${imagePath})`);
      } catch (error) {
        console.error('Errore nel caricamento dell\'immagine:', error);
        setBackgroundImage('none');
      } finally {
        setIsLoading(false);
      }
    };

    loadImage();

    const handleResize = debounce(() => {
      loadImage();
    }, 250);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [shouldShowBackground]);

  return { backgroundImage, isLoading };
};

export default useBackgroundImage;